function toCount(views: string | number): number {
  const n = typeof views === 'number' ? views : Number.parseInt(views, 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

function localeFor(language: string): string {
  return language === 'pt' || language.startsWith('pt-') ? 'pt-BR' : 'en-US';
}

export function formatLeaderboardViews(views: string | number, language: string): string {
  return new Intl.NumberFormat(localeFor(language), {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
  }).format(toCount(views));
}
